import { RootState } from "../../store";

export const cleanActionTypeSelector = (state: RootState) => state.clean.type;
